export const NoField = () => (
  <div style={{ textAlign: 'center', width: '100%' }}>-</div>
);
